import React from 'react';
import { useTranslation } from 'react-i18next';
import { Joyride, EVENTS, Step, EventData } from 'react-joyride';
import { useTheme } from '@mui/material/styles';

export const ONBOARDING_SEEN_KEY = 'onboarding_tour_seen';

type OnboardingTourProps = {
  run: boolean;
  onFinish: () => void;
};

export default function OnboardingTour({ run, onFinish }: OnboardingTourProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  const steps: Step[] = [
    {
      target: '[data-tour="tab-surveys"]',
      title: t('help.tour.surveys_title'),
      content: t('help.tour.surveys_body'),
    },
    {
      target: '[data-tour="tab-recordings"]',
      title: t('help.tour.recordings_title'),
      content: t('help.tour.recordings_body'),
    },
    {
      target: '[data-tour="tab-team-of-teams"]',
      title: t('help.tour.team_of_teams_title'),
      content: t('help.tour.team_of_teams_body'),
    },
    {
      target: '[data-tour="tab-teams"]',
      title: t('help.tour.teams_title'),
      content: t('help.tour.teams_body'),
    },
    {
      target: '[data-tour="help-button"]',
      title: t('help.tour.help_button_title'),
      content: t('help.tour.help_button_body'),
    },
  ];

  const handleEvent = (data: EventData) => {
    if (data.type === EVENTS.TOUR_END) {
      onFinish();
    }
  };

  return (
    <Joyride
      run={run}
      steps={steps}
      continuous
      onEvent={handleEvent}
      options={{
        buttons: ['back', 'skip', 'close', 'primary'],
        primaryColor: theme.palette.primary.main,
        zIndex: 1500,
      }}
      locale={{
        back: t('help.tour.back'),
        next: t('help.tour.next'),
        last: t('help.tour.last'),
        skip: t('help.tour.skip'),
      }}
    />
  );
}
